import { render } from "./TheRecommendedModels.vue?vue&type=template&id=250198ae&scoped=true"
import script from "./TheRecommendedModels.vue?vue&type=script&lang=js"
export * from "./TheRecommendedModels.vue?vue&type=script&lang=js"

import "./TheRecommendedModels.vue?vue&type=style&index=0&id=250198ae&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-250198ae"

export default script